<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Attendance',
  page: {
    title: 'Attendance',
    meta: [{ name: 'description', content: 'Attendance' }],
  },
}
</script>
